import { createApi } from '@reduxjs/toolkit/query/react'
import { getBaseQuery } from '../../Utils'
declare let window: any

export const workspaceApi = createApi({
    reducerPath: 'workspaceApi',
    baseQuery: getBaseQuery( window.healthLevelGlobal.urlPath + 'API/v3/' ),
    endpoints: (builder) => ({
        checkDeleteWorkspace: builder.mutation({
            query: (reqCheckDeleteDashBoard) => ({
                url: 'Workspace/CheckDelete',
                method: 'POST',
                body: reqCheckDeleteDashBoard,
            }),
        }),
        deleteWorkspace: builder.mutation({
            query: (dashBoardId) => ({
                url: 'Workspace/DeleteWorkspace',
                method: 'DELETE',
                body: dashBoardId,
            }),
        }),

        detachWorkspace: builder.mutation({
            query: (dashBoardId) => ({
                url: '/Workspace/Detach',
                method: 'POST',
                body: dashBoardId,
            }),
        }),

        createNewVisualUnit: builder.mutation({
            query: (reqCreateNewVU) => ({
                url: 'visualunit/Create',
                method: 'POST',
                body: reqCreateNewVU,
            }),
        }),

        // Fetch dashboard visual units for reordering
        fetchDashBoardVUs: builder.mutation({
            query: (dashBoardId) => ({
                url: `Workspace/ReorderDashBoardVUs`,
                method: 'GET',
                params: dashBoardId,
            }),
        }),

        // Reorder dashboard visual units
        reorderDashBoardVUs: builder.mutation({
            query: (formData) => ({
                url: `Workspace/ReorderDashBoardVUs`,
                method: 'POST',
                body: formData,
            }),
        }),

        getSharedUsersDashboard: builder.mutation({
            query: (dashBoardId) => ({
                url: 'Account/SharedUsers_Dashboard',
                method: 'POST',
                body: dashBoardId, // Pass dashBoardId in the request body
            }),
        }),
        shareDashboardUsers: builder.mutation({
            query: (reqShareDashBoardUser) => ({
                url: 'Account/ShareDashBoard_Users',
                method: 'PUT',
                body: reqShareDashBoardUser,
            }),
        }),

        getFilteredUsersShare: builder.mutation({
            query: (reqFilterUsersShareData) => ({
                url: 'Workspace/GetFilteredUsers_Share',
                method: 'POST',
                body: reqFilterUsersShareData,
            }),
            transformResponse: (response: any) => {
                if (response?.statusCode === 201 && response?.data) {
                    return response.data.map((user: any) => ({
                        DisplayText: `${user.FirstName} ${user.LastName} (<i>${user.EmailAddress}</i>)`,
                        KeyValue: user.UserId,
                    }))
                }
                throw new Error(response?.message || 'Failed to fetch filtered users')
            },
        }),

        getVisualUnits: builder.mutation({
            query: (reqGetAllVUs) => ({
                url: 'visualunit/search',
                method: 'POST',
                body: reqGetAllVUs,
            }),
            transformResponse: (response: any) => {
                if (response?.statusCode === 201 && response?.data) {
                    return response.data.map((visualUnitInfo: any) => ({
                        DisplayText: visualUnitInfo.name,
                        KeyValue: visualUnitInfo.id,
                        Description: visualUnitInfo.description,
                        CopyReport: true,
                        ViewerType: visualUnitInfo.viewerType,
                    }))
                }
                throw new Error(response?.message || 'Failed to fetch visual units')
            },
        }),

        sendWorkspaceAsPDF: builder.mutation({
            query: (wsid: string) => ({
                url: `Workspace/${wsid}/Email/pdf`,
                method: 'POST',
                body: null, // The API doesn’t require a request body
                headers: {
                    'Content-Type': 'application/json',
                    // Include authorization or other headers if required
                },
            }),
        }),
        getDBVisualUnits: builder.mutation({
            query: (dashBoardId: string) => ({
                url: `Workspace/${dashBoardId}/visualunits`,
                method: 'GET',
                params: { dashBoardId },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
            }),
        }),
        updateSelectedVisualUnits: builder.mutation({
            query: (formData) => {
                const workspaceId = formData.get('WorkspaceId')
                return {
                    url: `Workspace/${workspaceId}/visualunits`,
                    method: 'POST',
                    body: formData,
                }
            },
        }),

        fetchDashboard: builder.mutation({
            query: (dashBoardId) => ({
                url: `Workspace/GetDashBoard`,
                method: 'GET',
                params: { dashBoardId },
            }),
            transformResponse: (response: any) => {
                if (response?.statusCode === 200 && response?.data) {
                    return {
                        dashBoardName: response.data.dashBoardName,
                        dashBoardDescription: response.data.dashBoardDescription,
                        lockStatus: response.data.lockStatus,
                        allowEdit: response.data.allowEdit,
                        userFavWorkspace: response.data.UserFavWorkspace,
                    }
                }
                throw new Error(response?.message || 'Failed to fetch dashboard details')
            },
        }),
        editDashboard: builder.mutation({
            query: (reqEditDashBoard) => ({
                url: `Workspace/EditDashBoard`,
                method: 'PUT',
                body: reqEditDashBoard,
            }),
        }),
    }),
})

export const {
    useCheckDeleteWorkspaceMutation,
    useDeleteWorkspaceMutation,
    useDetachWorkspaceMutation,
    useCreateNewVisualUnitMutation,
    useFetchDashBoardVUsMutation,
    useReorderDashBoardVUsMutation,
    useGetSharedUsersDashboardMutation,
    useShareDashboardUsersMutation,
    useSendWorkspaceAsPDFMutation,
    useGetFilteredUsersShareMutation,
    useGetDBVisualUnitsMutation,
    useUpdateSelectedVisualUnitsMutation,
    useFetchDashboardMutation,
    useEditDashboardMutation,
    useGetVisualUnitsMutation,
} = workspaceApi
